export const colors = {
	trace: 'magenta',
	debug: 'blue',
	info: 'green',
	warn: 'yellow',
	error: 'red',
	fatal: 'bgRed',
}

export const levels = {
	trace: 5,
	debug: 4,
	info: 3,
	warn: 2,
	error: 1,
	fatal: 0,
}

export const parseBinder = {
	trace: {
		date: true,
		message: true,
		tag: false,
		action: false,
		details: 'optional',
	},
	debug: {
		date: true,
		message: true,
		tag: true,
		action: true,
		details: 'optional',
	},
	info: {
		date: true,
		message: true,
		tag: true,
		action: true,
		details: 'optional',
	},
	warn: {
		date: true,
		message: true,
		tag: true,
		action: true,
		details: true,
	},
	error: {
		date: true,
		message: true,
		tag: true,
		action: true,
		details: true,
	},
	fatal: {
		date: true,
		message: true,
		tag: true,
		action: true,
		details: true,
	},
}
